import PropTypes from "prop-types"
import { Link, Typography } from "@mui/material"
import { SUPPORT_EMAIL } from "helpers/constants"

export default function ErrorMessage({
  message = "An error occurred. Please try again.",
  showContactSupport = true,
  supportText = "Customer Success",
}) {
  const cta = window.Intercom ? <Link
    component="a"
    onClick={() => window.Intercom("showNewMessage", "")}
    sx={{
      fontWeight: "bold",
      textDecoration: "underline",
      cursor: "pointer",
    }}
  >
    {supportText}
  </Link> : <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>

  return (
    <Typography variant="body2" className="error-message">
      {message}
      {showContactSupport && <>Please contact {cta} if the error persists.</>}
    </Typography>
  )
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
  showContactSupport: PropTypes.bool,
  supportText: PropTypes.string,
}
